// Mapping of country names/codes to Lat/Lng coordinates
// Updated with accurate capital/central city coordinates

export const countryCoordinates: { [key: string]: [number, number] } = {
    // North America
    "United States": [39.8283, -98.5795],
    "US": [39.8283, -98.5795],
    "USA": [39.8283, -98.5795],
    "Canada": [56.1304, -106.3468],
    "CA": [56.1304, -106.3468],
    "Mexico": [23.6345, -102.5528],
    "MX": [23.6345, -102.5528],

    // Europe
    "United Kingdom": [54.3781, -2.4360],
    "UK": [54.3781, -2.4360],
    "GB": [54.3781, -2.4360],
    "Germany": [51.1657, 10.4515],
    "DE": [51.1657, 10.4515],
    "France": [46.6034, 1.8883],
    "FR": [46.6034, 1.8883],
    "Italy": [42.5046, 12.5736],
    "IT": [42.5046, 12.5736],
    "Spain": [40.4637, -3.7492],
    "ES": [40.4637, -3.7492],
    "Netherlands": [52.3676, 4.9041],
    "NL": [52.3676, 4.9041],
    "Sweden": [62.1282, 17.6435],
    "SE": [62.1282, 17.6435],
    "Norway": [64.4720, 11.4689],
    "NO": [64.4720, 11.4689],
    "Ireland": [53.4129, -8.2439],
    "IE": [53.4129, -8.2439],
    "Switzerland": [46.8182, 8.2275],
    "CH": [46.8182, 8.2275],
    "Belgium": [50.8503, 4.3517],
    "BE": [50.8503, 4.3517],
    "Denmark": [56.2639, 9.5018],
    "DK": [56.2639, 9.5018],
    "Finland": [64.9241, 26.7482],
    "FI": [64.9241, 26.7482],
    "Portugal": [39.3999, -8.2245],
    "PT": [39.3999, -8.2245],
    "Poland": [51.9194, 19.1451],
    "PL": [51.9194, 19.1451],
    "Austria": [47.5162, 14.5501],
    "AT": [47.5162, 14.5501],
    "Greece": [39.0742, 21.8243],
    "GR": [39.0742, 21.8243],
    "Czech Republic": [49.8175, 15.4730],
    "CZ": [49.8175, 15.4730],
    "Romania": [45.9432, 24.9668],
    "RO": [45.9432, 24.9668],
    "Hungary": [47.1625, 19.5033],
    "HU": [47.1625, 19.5033],
    "Ukraine": [48.3794, 31.1656],
    "UA": [48.3794, 31.1656],
    "Russia": [55.7558, 37.6173],
    "RU": [55.7558, 37.6173],

    // Asia
    "India": [20.5937, 78.9629],
    "IN": [20.5937, 78.9629],
    "Japan": [36.2048, 138.2529],
    "JP": [36.2048, 138.2529],
    "China": [35.8617, 104.1954],
    "CN": [35.8617, 104.1954],
    "South Korea": [36.5000, 127.5000],
    "KR": [36.5000, 127.5000],
    "Singapore": [1.3521, 103.8198],
    "SG": [1.3521, 103.8198],
    "Indonesia": [-2.5489, 118.0149],
    "ID": [-2.5489, 118.0149],
    "Vietnam": [16.0583, 108.2772],
    "VN": [16.0583, 108.2772],
    "Thailand": [15.8700, 100.9925],
    "TH": [15.8700, 100.9925],
    "Malaysia": [4.2105, 101.9758],
    "MY": [4.2105, 101.9758],
    "Philippines": [12.8797, 121.7740],
    "PH": [12.8797, 121.7740],
    "Pakistan": [30.3753, 69.3451],
    "PK": [30.3753, 69.3451],
    "Bangladesh": [23.6850, 90.3563],
    "BD": [23.6850, 90.3563],
    "Taiwan": [23.6978, 120.9605],
    "TW": [23.6978, 120.9605],
    "Hong Kong": [22.3193, 114.1694],
    "HK": [22.3193, 114.1694],

    // Middle East
    "Turkey": [38.9637, 35.2433],
    "TR": [38.9637, 35.2433],
    "Saudi Arabia": [23.8859, 45.0792],
    "SA": [23.8859, 45.0792],
    "UAE": [24.4539, 54.3773],
    "United Arab Emirates": [24.4539, 54.3773],
    "AE": [24.4539, 54.3773],
    "Israel": [31.7683, 35.2137],
    "IL": [31.7683, 35.2137],
    "Qatar": [25.3548, 51.1839],
    "QA": [25.3548, 51.1839],
    "Kuwait": [29.3759, 47.9774],
    "KW": [29.3759, 47.9774],
    "Iran": [32.4279, 53.6880],
    "IR": [32.4279, 53.6880],

    // Africa
    "South Africa": [-30.5595, 22.9375],
    "ZA": [-30.5595, 22.9375],
    "Egypt": [26.8206, 30.8025],
    "EG": [26.8206, 30.8025],
    "Nigeria": [9.0820, 8.6753],
    "NG": [9.0820, 8.6753],
    "Kenya": [-1.2921, 36.8219],
    "KE": [-1.2921, 36.8219],
    "Morocco": [31.7917, -7.0926],
    "MA": [31.7917, -7.0926],
    "Ghana": [7.9465, -1.0232],
    "GH": [7.9465, -1.0232],
    "Ethiopia": [9.1450, 40.4897],
    "ET": [9.1450, 40.4897],
    "Tanzania": [-6.3690, 34.8888],
    "TZ": [-6.3690, 34.8888],
    "Uganda": [1.3733, 32.2903],
    "UG": [1.3733, 32.2903],
    "Cameroon": [5.9631, 10.1591],
    "CM": [5.9631, 10.1591],
    "Ivory Coast": [7.5400, -5.5471],
    "CI": [7.5400, -5.5471],
    "Senegal": [14.4974, -14.4524],
    "SN": [14.4974, -14.4524],

    // South America
    "Brazil": [-14.2350, -51.9253],
    "BR": [-14.2350, -51.9253],
    "Argentina": [-38.4161, -63.6167],
    "AR": [-38.4161, -63.6167],
    "Colombia": [4.5709, -74.2973],
    "CO": [4.5709, -74.2973],
    "Chile": [-35.6751, -71.5430],
    "CL": [-35.6751, -71.5430],
    "Peru": [-9.1900, -75.0152],
    "PE": [-9.1900, -75.0152],
    "Venezuela": [6.4238, -66.5897],
    "VE": [6.4238, -66.5897],
    "Ecuador": [-1.8312, -78.1834],
    "EC": [-1.8312, -78.1834],
    "Uruguay": [-32.5228, -55.7658],
    "UY": [-32.5228, -55.7658],
    "Paraguay": [-23.4425, -58.4438],
    "PY": [-23.4425, -58.4438],
    "Bolivia": [-16.2902, -63.5887],
    "BO": [-16.2902, -63.5887],

    // Oceania
    "Australia": [-25.2744, 133.7751],
    "AU": [-25.2744, 133.7751],
    "New Zealand": [-40.9006, 174.8860],
    "NZ": [-40.9006, 174.8860],

    // Central America & Caribbean
    "Costa Rica": [9.7489, -83.7534],
    "CR": [9.7489, -83.7534],
    "Panama": [8.5380, -80.7821],
    "PA": [8.5380, -80.7821],
    "Jamaica": [18.1096, -77.2975],
    "JM": [18.1096, -77.2975],
    "Dominican Republic": [18.7357, -70.1627],
    "DO": [18.7357, -70.1627],
    "Puerto Rico": [18.2208, -66.5901],
    "PR": [18.2208, -66.5901],
    "Cuba": [21.5218, -77.7812],
    "CU": [21.5218, -77.7812],
    "Guatemala": [15.7835, -90.2308],
    "GT": [15.7835, -90.2308],
    "Honduras": [15.2000, -86.2419],
    "HN": [15.2000, -86.2419],
    "El Salvador": [13.7942, -88.8965],
    "SV": [13.7942, -88.8965],
    "Nicaragua": [12.8654, -85.2072],
    "NI": [12.8654, -85.2072],

    // Additional Asian countries
    "Sri Lanka": [7.8731, 80.7718],
    "LK": [7.8731, 80.7718],
    "Nepal": [28.3949, 84.1240],
    "NP": [28.3949, 84.1240],
    "Myanmar": [21.9162, 95.9560],
    "MM": [21.9162, 95.9560],
    "Cambodia": [12.5657, 104.9910],
    "KH": [12.5657, 104.9910],
    "Laos": [19.8563, 102.4955],
    "LA": [19.8563, 102.4955],
};

export const getCoordinates = (countryName: string): [number, number] | null => {
    // Try direct match
    if (countryCoordinates[countryName]) {
        return countryCoordinates[countryName];
    }

    // Try case-insensitive match
    const lowerName = countryName.toLowerCase();
    const match = Object.keys(countryCoordinates).find(key => key.toLowerCase() === lowerName);

    if (match) {
        return countryCoordinates[match];
    }

    // Log unmatched countries for debugging
    console.warn(`No coordinates found for country: ${countryName}`);

    // Default fallback (null) - caller should handle this
    return null;
};
